export default __webpack_public_path__ + "images/4793c7d67879d011e0d8590c66c446f7.svg";